/*Bss custom Register form*/
if(window.location.pathname == '/pages/wholesale-registration-form-lycon') {
  
  const form = document.querySelector("#RegisterForm");
  const div1 = document.createElement("div");
  const div2 = document.createElement("div");
  div1.setAttribute("class", "bss-div-1");
  div2.setAttribute("class", "bss-div-2");
  // form.prepend(div1);
  // div1.after(div2);
  const acountInfo = document.querySelectorAll(".field");
  acountInfo.forEach(field => {
    div1.appendChild(field);
  })
  const customerInfo = document.querySelectorAll(".rendered-form .form-group");
  const customerArr = Array.from(customerInfo);
  customerArr.forEach((info, index) => {
    if( index < 4) {
      div2.appendChild(info);
    }
  })
  const label1 = document.querySelector(".rendered-form div h1");
  const module1 = document.createElement("div");
  module1.setAttribute("class", "module bss-module-1");
  form.prepend(module1);
  module1.appendChild(div1);
  module1.appendChild(div2);
  form.prepend(label1);
  
  const div3 = document.createElement("div");
  const div4 = document.createElement("div");
  const div5 = document.createElement("div");
  const div6 = document.createElement("div");
  const div7 = document.createElement("div");
  const div8 = document.createElement("div");
  const div9 = document.createElement("div");
  
  div3.setAttribute("class", "bss-div-3");
  div4.setAttribute("class", "bss-div-4");
  div5.setAttribute("class", "bss-div-5");
  div6.setAttribute("class", "bss-div-6");
  div7.setAttribute("class", "bss-div-7");
  div8.setAttribute("class", "bss-div-8");
  div9.setAttribute("class", "bss-div-9");
  const businessInfo = document.querySelectorAll(".rendered-form .form-group");
  const businessInfoArr = Array.from(businessInfo);
  businessInfoArr.forEach((info, index) =>{
    if(index < 7){
      div3.appendChild(info);
    }
    if(index >= 7 && index < 11) {
      div4.appendChild(info);
    }
    if(index == 11) {
      div5.appendChild(info);
    }
    if(index > 11 && index < 17) {
      div6.appendChild(info);
    }
    if(index >= 17 && index < 21) {
      div7.appendChild(info);
    }
    if( index >= 21 && index < 23) {
      div8.appendChild(info);
    }
    if(index == 24 ) {
     //
    }
    if( index >=23 && index != 24) {
      div9.appendChild(info);
    }
  })
  const label3 = document.querySelector("#bss-b2b-registration-form-render .rendered-form div h1");
  div3.prepend(label3);
  const label4 = document.querySelector("#bss-b2b-registration-form-render .rendered-form div h1");
  div4.prepend(label4);
  const module2 = document.createElement("div");
  module2.setAttribute("class", "module bss-module-2");
  module2.appendChild(div3);
  module2.appendChild(div4);
  form.appendChild(module2);
  const module3 = document.createElement("div");
  label5 = document.querySelector("#bss-b2b-registration-form-render .rendered-form div h1");
  module3.setAttribute("class", "module bss-module-3");
  module3.appendChild(div5);
  module3.prepend(label5)
  form.appendChild(module3);
  const module4 = document.createElement("div");
  module4.setAttribute("class", "module bss-module-4")
  module4.appendChild(div6);
  module4.appendChild(div7);
  form.appendChild(module4);
  const module5 = document.createElement("div");
  module5.setAttribute("class", "module bss-module-5");
  const label6 = document.querySelector("#bss-b2b-registration-form-render .rendered-form div h1");
  const fileField = document.querySelector("#bss-b2b-registration-form-render .rendered-form .formbuilder-file");
  module5.prepend(label6);
  module5.appendChild(fileField);
  form.appendChild(module5);
  const module6 = document.createElement("div");
  module6.setAttribute("class", "module bss-module-6");
  module6.appendChild(div8);
  module6.appendChild(div9);
  form.appendChild(module6);
  const submitBtn = document.querySelector("#RegisterForm .text-center");
  module6.after(submitBtn);
  let header = document.querySelector("div.grid__item.medium-up--five-sixths.medium-up--push-one-twelfth > div.section-header.text-center");
  let headerContent = document.createElement("div");
  headerContent.setAttribute("style", "text-align: center;  margin-top: 20px;");
  headerContent.setAttribute("class", "bss-custom-header")
  let content = `<span style = "font-family: 'Outfit'; font-size: medium; letter-spacing: 1.5px; font-size: 24px;">REGISTER FOR A NEW TRADE ACCOUNT</span></br></br>
  <span style = "font-family:'Montserrat';">Want to trade with the best brands in beauty?</span></br></br><span style = "font-family:'Montserrat';">We'd love for you to join us here at <span style="font-weight: 600">Beauty Triangle International</span>; the exclusive home of <span style="font-weight: 600">LYCON UK.</span></span>
  </br></br><span style = "font-family: 'Montserrat';">First, we just need to learn a little more about you. Please complete the below registration form and a member of our team will review it within 2 working days.</span>
  `;
  headerContent.innerHTML = content;
  header.after(headerContent);
  let oldHeader = document.querySelector("#main > div > div > div.grid__item.medium-up--five-sixths.medium-up--push-one-twelfth > div.section-header.text-center");
  oldHeader.remove();

  //required in firstname, lastname,email,password field
  const defaultField = document.querySelectorAll(".bss-module-1 .bss-div-1 .field label , .bss_rf_privacy_policy_container");
  if(defaultField.length > 0){
    defaultField.forEach(item => {
      console.log("aaaaaa")
      item.innerHTML += '<span class="formbuilder-required">*</span>'
    })
  }

  //required set require 
   const defaultConfirm= document.querySelector(" #bss_rf_privacy_policy");
   if(defaultConfirm){
     
    defaultConfirm.checked = true 
  }

  //handle require lastname
  setTimeout(() =>{
    function handleErrLastName() {
      const lstNameVal = $("#RegisterForm-LastName").val();
      return !!lstNameVal;
    }
    let spanError = $(
      `<span class="bss-error-msg" style="color: #ff0000; text-align: center;display: block; margin: auto; margin-bottom: 15px;"><span class="bss-b2b-translation-rf-required_field" style="color: #ff0000">This field is required</span></span>`
    );
    $(`input[type="submit"]`).on("click", (e) => {
      if (!handleErrLastName()) {
        e.preventDefault();
        if (
          $("#RegisterForm-LastName").parent().find(".bss-error-msg").length === 0
        ) {
          $("#RegisterForm-LastName").after(spanError);
        }
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $("#RegisterForm-LastName").offset().top - 100,
          },
          600
        );
      }
    });
  },300)
  
}
if(window.location.pathname == '/pages/wholesale-registration-form') {
  let header = document.querySelector("div.grid__item.medium-up--five-sixths.medium-up--push-one-twelfth > div.section-header.text-center");
  let headerContent = document.createElement("div");
  headerContent.setAttribute("style", "text-align: center;  margin-top: 20px;");
  headerContent.setAttribute("class", "bss-custom-header")
  let content = `<span style = "font-family: 'Outfit'; font-size: medium; letter-spacing: 1.5px; font-size: 24px;">REGISTER FOR A NEW TRADE ACCOUNT</span></br></br>
  <span style = "font-family:'Montserrat';">Want to trade with the best brands in beauty?</span></br></br><span style = "font-family:'Montserrat';">We'd love for you to join us here at <span style="font-weight: 600">Beauty Triangle International</span>; the exclusive home of <span style="font-weight: 600">LYCON UK, Supercilium & South Seas.</span></span>
  </br></br><span style = "font-family: 'Montserrat';">First, we just need to learn a little more about you. Please complete the below registration form and a member of our team will review it within 2 working days.</span>
  `;
  headerContent.innerHTML = content;
  header.after(headerContent);
     //required in firstname, lastname,email,password field
  const defaultField = document.querySelectorAll(".field label , .bss_rf_privacy_policy_container");
  if(defaultField.length > 0){
    defaultField.forEach(item => {
      item.innerHTML += '<span class="formbuilder-required">*</span>'
    })
  }
  //required set require 
   const defaultConfirm= document.querySelector(" #bss_rf_privacy_policy");
   if(defaultConfirm){
    defaultConfirm.checked = true 
  }

  //handle require lastname
  setTimeout(() =>{
    function handleErrLastName() {
      const lstNameVal = $("#RegisterForm-LastName").val();
      return !!lstNameVal;
    }
    let spanError = $(
      `<span class="bss-error-msg" style="color: #ff0000; text-align: center;display: block; margin: auto; margin-bottom: 15px;"><span class="bss-b2b-translation-rf-required_field" style="color: #ff0000">This field is required</span></span>`
    );
    $(`input[type="submit"]`).on("click", (e) => {
      if (!handleErrLastName()) {
        e.preventDefault();
        if (
          $("#RegisterForm-LastName").parent().find(".bss-error-msg").length === 0
        ) {
          $("#RegisterForm-LastName").after(spanError);
        }
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $("#RegisterForm-LastName").offset().top - 100,
          },
          600
        );
      }
    });
  },300)
}
/*End Bss custom Register form*/
